// ==============================================================================
// Story 006: Tokero! Taiyaki-kun (Episode 1)
// ==============================================================================

const STORY_DATA = [
  // ==========================================
  // Part 1
  // ==========================================
  {
    title: "Part 1: The End of the Escape (1/4)",
    rubyText: [
      { w: "Every", r: "エブリ" }, { w: "day,", r: "デイ", s: true }, { w: "I", r: "アイ" }, { w: "was", r: "ワズ" }, { w: "baked", r: "ベイクト" }, { w: "on", r: "オン" }, { w: "an", r: "アン" }, { w: "iron", r: "アイアン" }, { w: "plate.", r: "プレイト", s: true }, 
      { w: "Making", r: "メイキング" }, { w: "a", r: "ア" }, { w: "sizzling", r: "シズリング" }, { w: "sound,", r: "サウンド", s: true }, { w: "over", r: "オーバー" }, { w: "and", r: "アンド" }, { w: "over.", r: "オーバー", s: true }, 
      { w: "Honestly,", r: "オネストリー", s: true }, { w: "I", r: "アイ" }, { w: "was", r: "ワズ" }, { w: "already", r: "オールレディ" }, { w: "sick", r: "シック" }, { w: "of", r: "オブ" }, { w: "it.", r: "イット", s: true }, 
      { w: "One", r: "ワン" }, { w: "morning,", r: "モーニング", s: true }, { w: "I", r: "アイ" }, { w: "finally", r: "ファイナリー" }, { w: "had", r: "ハド" }, { w: "a", r: "ア" }, { w: "big", r: "ビッグ" }, { w: "fight", r: "ファイト" }, 
      { w: "with", r: "ウィズ" }, { w: "the", r: "ザ" }, { w: "man", r: "マン" }, { w: "at", r: "アット" }, { w: "the", r: "ザ" }, { w: "shop.", r: "ショップ", s: true }, 
      { w: "I", r: "アイ" }, { w: "ran", r: "ラン" }, { w: "out", r: "アウト" }, { w: "of", r: "オブ" }, { w: "the", r: "ザ" }, { w: "shop,", r: "ショップ", s: true }, 
      { w: "and", r: "アンド" }, { w: "escaped", r: "エスケイプト" }, { w: "right", r: "ライト" }, { w: "into", r: "イントゥ" }, { w: "the", r: "ザ" }, { w: "sea.", r: "シー", s: true }
    ],
    en: "Every day, I was baked on an iron plate.\nMaking a sizzling sound, over and over.\nHonestly, I was already sick of it.\nOne morning, I finally had a big fight\nwith the man at the shop.\nI ran out of the shop,\nand escaped right into the sea.",
    ja: "毎日毎日、ぼくは鉄板の上で焼かれていた。\nジュウジュウと音を立てながら、何度も何度も。\n正直、もううんざりだった。\nある朝、ついに店のおじさんと大げんかをした。\nぼくは店を飛び出し、そのまま海へ逃げこんだ。",
    learning: {
      vocab: [
        { word: "iron plate", mean: "鉄板" },
        { word: "sizzling", mean: "ジュウジュウと音を立てる" },
        { word: "sick of ~", mean: "～にうんざりして" },
        { word: "fight", mean: "喧嘩" },
        { word: "escape", mean: "逃げる" }
      ],
      grammar: {
        title: "過去受動態 (was/were + 過去分詞)",
        desc: "「〜された」という過去の受け身の表現です。「I was baked（私は焼かれた）」のように使います。",
        key: "I was baked on an iron plate."
      }
    },
    color: "bg-stone-200", accent: "text-stone-600", mood: { rate: 0.9, pitch: 0.9 }, image: "images/006/01.jpg", startTime: 0
  },
  {
    title: "Part 1: The End of the Escape (2/4)",
    rubyText: [
      { w: "Swimming", r: "スイミング" }, { w: "in", r: "イン" }, { w: "the", r: "ザ" }, { w: "sea", r: "シー" }, { w: "for", r: "フォー" }, { w: "the", r: "ザ" }, { w: "first", r: "ファースト" }, { w: "time", r: "タイム", s: true }, 
      { w: "felt", r: "フェルト" }, { w: "really", r: "リアリー" }, { w: "good.", r: "グッド", s: true }, 
      { w: "It", r: "イット" }, { w: "was", r: "ワズ" }, { w: "wide,", r: "ワイド", s: true }, { w: "free,", r: "フリー", s: true }, { w: "and", r: "アンド" }, { w: "endless.", r: "エンドレス", s: true }, 
      { w: "Sometimes", r: "サムタイムズ" }, { w: "I", r: "アイ" }, { w: "had", r: "ハド" }, { w: "scary", r: "スケアリー" }, { w: "experiences,", r: "エクスペリエンスズ", s: true }, 
      { w: "but", r: "バット" }, { w: "I", r: "アイ" }, { w: "had", r: "ハド" }, { w: "friends", r: "フレンズ" }, { w: "to", r: "トゥ" }, { w: "swim", r: "スイム" }, { w: "with", r: "ウィズ" }, { w: "here.", r: "ヒア", s: true }, 
      { w: "There", r: "ゼア" }, { w: "was", r: "ワズ" }, { w: "plenty", r: "プレンティ" }, { w: "of", r: "オブ" }, { w: "food,", r: "フード", s: true }, { w: "too.", r: "トゥー", s: true }, 
      { w: "I", r: "アイ" }, { w: "believed", r: "ビリーブド" }, { w: "these", r: "ジーズ" }, { w: "fun", r: "ファン" }, { w: "days", r: "デイズ", s: true }, 
      { w: "would", r: "ウッド" }, { w: "last", r: "ラスト" }, { w: "forever.", r: "フォーエバー", s: true }
    ],
    en: "Swimming in the sea for the first time\nfelt really good.\nIt was wide, free, and endless.\nSometimes I had scary experiences,\nbut I had friends to swim with here.\nThere was plenty of food, too.\nI believed these fun days\nwould last forever.",
    ja: "初めて泳ぐ海は、とても気持ちよかった。\n広くて、自由で、どこまでも続いていた。\nときどき怖い目にもあったけれど、\nここには一緒に泳ぐ仲間がいた。\nエサもたくさんあった。\nこんな楽しい毎日が、ずっと続くと信じていた。",
    learning: {
      vocab: [
        { word: "for the first time", mean: "初めて" },
        { word: "endless", mean: "終わりのない、どこまでも続く" },
        { word: "experience", mean: "経験、体験" },
        { word: "plenty of ~", mean: "たくさんの〜" },
        { word: "last", mean: "（動詞）続く" },
        { word: "forever", mean: "永遠に" }
      ],
      grammar: {
        title: "不定詞の形容詞的用法 (名詞 + to + 動詞)",
        desc: "名詞の後ろに「to + 動詞」を置いて、「〜するための」と説明を加えます。「friends to swim with（一緒に泳ぐための仲間）」となります。",
        key: "...friends to swim with here."
      }
    },
    color: "bg-sky-50", accent: "text-sky-600", mood: { rate: 0.95, pitch: 1.0 }, image: "images/006/02.jpg", startTime: 20
  },
  {
    title: "Part 1: The End of the Escape (3/4)",
    rubyText: [
      { w: "But", r: "バット", s: true }, { w: "the", r: "ザ" }, { w: "end", r: "エンド" }, { w: "came", r: "ケイム" }, { w: "suddenly.", r: "サドゥンリー", s: true }, 
      { w: "One", r: "ワン" }, { w: "day,", r: "デイ", s: true }, { w: "I", r: "アイ" }, { w: "casually", r: "カジュアリー" }, { w: "bit", r: "ビット" }, { w: "a", r: "ア" }, { w: "shrimp,", r: "シュリンプ", s: true }, 
      { w: "and", r: "アンド" }, { w: "it", r: "イット" }, { w: "had", r: "ハド" }, { w: "a", r: "ア" }, { w: "small", r: "スモール" }, { w: "fishhook", r: "フィッシュフック" }, { w: "on", r: "オン" }, { w: "it.", r: "イット", s: true }, 
      { w: "You", r: "ユー" }, { w: "can", r: "キャン" }, { w: "probably", r: "プロバブリー" }, { w: "imagine", r: "イマジン", s: true }, 
      { w: "what", r: "ホワット" }, { w: "happened", r: "ハプンド" }, { w: "next.", r: "ネクスト", s: true }, 
      { w: "Now,", r: "ナウ", s: true }, { w: "I", r: "アイ" }, { w: "am", r: "アム" }, { w: "in", r: "イン" }, { w: "the", r: "ザ" }, { w: "man's", r: "マンズ" }, { w: "mouth.", r: "マウス", s: true }
    ],
    en: "But the end came suddenly.\nOne day, I casually bit a shrimp,\nand it had a small fishhook on it.\nYou can probably imagine\nwhat happened next.\nNow, I am in the man's mouth.",
    ja: "だけど、その終わりは突然やってきた。\nある日、何気なくかじったエビに、\n小さな釣り針がついていたんだ。\nそれからどうなったかは、知ってのとおりさ。\nぼくは今、おじさんの口の中にいる。",
    learning: {
      vocab: [
        { word: "suddenly", mean: "突然" },
        { word: "casually", mean: "何気なく、ふと" },
        { word: "shrimp", mean: "エビ" },
        { word: "fishhook", mean: "釣り針" },
        { word: "probably", mean: "おそらく、たぶん" },
        { word: "imagine", mean: "想像する" }
      ],
      grammar: {
        title: "間接疑問文 (疑問詞 + 主語 + 動詞)",
        desc: "疑問文が文の一部になっている形です。「what happened next（次に何が起きたか）」を imagine の目的語として使っています。",
        key: "You can probably imagine what happened next."
      }
    },
    color: "bg-slate-100", accent: "text-slate-600", mood: { rate: 0.85, pitch: 0.8 }, image: "images/006/03.jpg", startTime: 40
  },
  {
    title: "Part 1: The End of the Escape (4/4)",
    rubyText: [
      { w: "Damp", r: "ダンプ" }, { w: "darkness.", r: "ダークネス", s: true }, 
      { w: "A", r: "ア" }, { w: "heavy,", r: "ヘヴィ", s: true }, { w: "regular", r: "レギュラー" }, { w: "chewing", r: "チューイング" }, { w: "sound.", r: "サウンド", s: true }, 
      { w: "\"Ah...", r: "アー", s: true }, { w: "my", r: "マイ" }, { w: "body", r: "ボディ" }, { w: "is", r: "イズ" }, { w: "breaking", r: "ブレイキング" }, { w: "apart.\"", r: "アパート", s: true }, 
      { w: "\"I", r: "アイ" }, { w: "won't", r: "ウォント" }, { w: "be", r: "ビー" }, { w: "able", r: "エイブル" }, { w: "to", r: "トゥ" }, { w: "swim", r: "スイム" }, { w: "anymore.\"", r: "エニモア", s: true }, 
      { w: "While", r: "ホワイル" }, { w: "I", r: "アイ" }, { w: "was", r: "ワズ" }, { w: "thinking", r: "シンキング" }, { w: "about", r: "アバウト" }, { w: "that,", r: "ザット", s: true }, 
      { w: "my", r: "マイ" }, { w: "body", r: "ボディ" }, { w: "was", r: "ワズ" }, { w: "crushed", r: "クラッシュト" }, { w: "finer", r: "ファイナー" }, { w: "and", r: "アンド" }, { w: "finer.", r: "ファイナー", s: true }, 
      { w: "And", r: "アンド" }, { w: "then,", r: "ゼン", s: true }, { w: "I", r: "アイ" }, { w: "was", r: "ワズ" }, { w: "sent", r: "セント" }, { w: "deep", r: "ディープ", s: true }, 
      { w: "into", r: "イントゥ" }, { w: "the", r: "ザ" }, { w: "dark", r: "ダーク" }, { w: "inside.", r: "インサイド", s: true }
    ],
    en: "Damp darkness.\nA heavy, regular chewing sound.\n\"Ah... my body is breaking apart.\"\n\"I won't be able to swim anymore.\"\nWhile I was thinking about that,\nmy body was crushed finer and finer.\nAnd then, I was sent deep\ninto the dark inside.",
    ja: "湿った闇。\n重く、規則正しい咀嚼の音。\n「ああ……ぼくの体が、バラバラになっていく。」\n「もう泳げなくなっちゃうよ。」\nそう思っているうちにも、\nぼくの体はどんどん細かく砕かれていった。\nそしてぼくは、暗い奥へと送り込まれていった。",
    learning: {
      vocab: [
        { word: "damp", mean: "湿った、ジメジメした" },
        { word: "chew", mean: "噛む、咀嚼する" },
        { word: "break apart", mean: "バラバラに壊れる" },
        { word: "anymore", mean: "（否定文で）これ以上〜ない" },
        { word: "crush", mean: "押しつぶす、砕く" },
        { word: "finer", mean: "より細かく（fineの比較級）" }
      ],
      grammar: {
        title: "比較級 and 比較級",
        desc: "「ますます〜、だんだん〜」と変化が進行していく様子を表します。「finer and finer」で「どんどん細かく」となります。",
        key: "...my body was crushed finer and finer."
      }
    },
    color: "bg-zinc-200", accent: "text-zinc-700", mood: { rate: 0.8, pitch: 0.7 }, image: "images/006/04.jpg", startTime: 60
  },

  // ==========================================
  // Part 2
  // ==========================================
  {
    title: "Part 2: The Transformation Ritual (1/4)",
    rubyText: [
      { w: "Just", r: "ジャスト" }, { w: "then,", r: "ゼン", s: true }, { w: "I", r: "アイ" }, { w: "felt", r: "フェルト" }, { w: "someone's", r: "サムワンズ" }, { w: "presence.", r: "プレゼンス", s: true }, 
      { w: "I", r: "アイ" }, { w: "turned", r: "ターンド" }, { w: "around", r: "アラウンド", s: true }, { w: "and", r: "アンド" }, { w: "saw", r: "ソー" }, { w: "a", r: "ア" }, { w: "woman", r: "ウーマン", s: true }, 
      { w: "standing", r: "スタンディング" }, { w: "there", r: "ゼア" }, { w: "with", r: "ウィズ" }, { w: "scissors.", r: "シザーズ", s: true }, 
      { w: "\"Eek.", r: "イーク", s: true }, { w: "Who", r: "フー" }, { w: "are", r: "アー" }, { w: "you?\"", r: "ユー", s: true }, 
      { w: "She", r: "シー" }, { w: "smiled", r: "スマイルド" }, { w: "gently.", r: "ジェントリー", s: true }, 
      { w: "\"I", r: "アイ" }, { w: "am", r: "アム" }, { w: "Amylase.", r: "アミラーゼ", s: true }, 
      { w: "I", r: "アイ" }, { w: "am", r: "アム" }, { w: "helping", r: "ヘルピング" }, { w: "to", r: "トゥ" }, { w: "untie", r: "アンタイ" }, { w: "your", r: "ユア" }, { w: "body.\"", r: "ボディ", s: true }, 
      { w: "\"Untie?\"", r: "アンタイ", s: true }
    ],
    en: "Just then, I felt someone's presence.\nI turned around and saw a woman\nstanding there with scissors.\n\"Eek. Who are you?\"\nShe smiled gently.\n\"I am Amylase.\nI am helping to untie your body.\"\n\"Untie?\"",
    ja: "そのとき、ふと人の気配がした。\n振り向くと、ハサミを持った一人の女性が立っていた。\n「ひゃっ。きみは、だれ？」\n彼女はやさしく微笑んだ。\n「私はアミラーゼ。\nあなたの体をほどくお手伝いをしているの。」\n「ほどく？」",
    learning: {
      vocab: [
        { word: "presence", mean: "気配、存在" },
        { word: "turn around", mean: "振り向く" },
        { word: "scissors", mean: "ハサミ" },
        { word: "gently", mean: "優しく" },
        { word: "untie", mean: "ほどく" }
      ],
      grammar: {
        title: "知覚動詞 (see / feel + O + -ing)",
        desc: "「O（目的語）が〜しているのを見る・感じる」という表現です。知覚動詞（see, hear, feel など）のあとに目的語＋現在分詞（-ing）が続くのが典型形で、「saw a woman standing」で「女性が立っているのを見た」となります。目的語に名詞のみを続ける形（felt someone's presence）もあります。",
        key: "I saw a woman standing there..."
      }
    },
    color: "bg-rose-50", accent: "text-rose-600", mood: { rate: 0.9, pitch: 1.1 }, image: "images/006/05.jpg", startTime: 80
  },
  {
    title: "Part 2: The Transformation Ritual (2/4)",
    rubyText: [
      { w: "Amylase", r: "アミラーゼ" }, { w: "quietly", r: "クワイエットリー" }, { w: "moved", r: "ムーブド" }, { w: "her", r: "ハー" }, { w: "scissors.", r: "シザーズ", s: true }, 
      { w: "Snip.", r: "スニップ", s: true }, { w: "Snip.", r: "スニップ", s: true }, 
      { w: "\"Your", r: "ユア" }, { w: "body", r: "ボディ" }, { w: "is", r: "イズ" }, { w: "starch.", r: "スターチ", s: true }, 
      { w: "It", r: "イット" }, { w: "is", r: "イズ" }, { w: "made", r: "メイド" }, { w: "of", r: "オブ" }, { w: "long,", r: "ロング", s: true }, { w: "connected", r: "コネクティッド" }, { w: "chains.\"", r: "チェインズ", s: true }, 
      { w: "\"My", r: "マイ" }, { w: "true", r: "トゥルー" }, { w: "identity", r: "アイデンティティ" }, { w: "is...", r: "イズ", s: true }, { w: "starch?\"", r: "スターチ", s: true }, 
      { w: "\"Yes.", r: "イエス", s: true }, 
      { w: "And", r: "アンド" }, { w: "untying", r: "アンタイイング" }, { w: "those", r: "ゾーズ" }, { w: "chains", r: "チェインズ", s: true }, { w: "is", r: "イズ" }, { w: "my", r: "マイ" }, { w: "job.\"", r: "ジョブ", s: true }
    ],
    en: "Amylase quietly moved her scissors.\nSnip. Snip.\n\"Your body is starch.\nIt is made of long, connected chains.\"\n\"My true identity is... starch?\"\n\"Yes.\nAnd untying those chains is my job.\"",
    ja: "アミラーゼは静かにハサミを動かした。\nチョキン。\nチョキン。\n「あなたの体はデンプン。\n長くつながった鎖でできているの。」\n「ぼくの正体が……デンプン？」\n「そう。そしてその鎖をほどくことが、私の役目。」",
    learning: {
      vocab: [
        { word: "quietly", mean: "静かに" },
        { word: "starch", mean: "デンプン" },
        { word: "connected", mean: "つながった" },
        { word: "identity", mean: "正体、身元" },
        { word: "chain", mean: "鎖" }
      ],
      grammar: {
        title: "be made of ~",
        desc: "「〜からできている（材料）」という意味の熟語です。見て材料がわかる場合に使います。",
        key: "It is made of long, connected chains."
      }
    },
    color: "bg-fuchsia-50", accent: "text-fuchsia-600", mood: { rate: 0.95, pitch: 1.15 }, image: "images/006/06.jpg", startTime: 100
  },
  {
    title: "Part 2: The Transformation Ritual (3/4)",
    rubyText: [
      { w: "Every", r: "エブリ" }, { w: "time", r: "タイム", s: true }, { w: "the", r: "ザ" }, { w: "scissors", r: "シザーズ" }, { w: "moved,", r: "ムーブド", s: true }, 
      { w: "the", r: "ザ" }, { w: "chains", r: "チェインズ" }, { w: "in", r: "イン" }, { w: "my", r: "マイ" }, { w: "body", r: "ボディ" }, { w: "untied.", r: "アンタイド", s: true }, 
      { w: "My", r: "マイ" }, { w: "shape", r: "シェイプ" }, { w: "changed", r: "チェンジド" }, { w: "little", r: "リトル" }, { w: "by", r: "バイ" }, { w: "little.", r: "リトル", s: true }, 
      { w: "But,", r: "バット", s: true }, { w: "it", r: "イット" }, { w: "was", r: "ワズ" }, { w: "strange.", r: "ストレンジ", s: true }, 
      { w: "I", r: "アイ" }, { w: "did", r: "ディド" }, { w: "not", r: "ノット" }, { w: "feel", r: "フィール" }, { w: "bad.", r: "バッド", s: true }, 
      { w: "Rather,", r: "ラザー", s: true }, { w: "it", r: "イット" }, { w: "was", r: "ワズ" }, { w: "somewhat", r: "サムホワット" }, { w: "nostalgic.", r: "ノスタルジック", s: true }, 
      { w: "It", r: "イット" }, { w: "felt", r: "フェルト" }, { w: "like", r: "ライク", s: true }, { w: "I", r: "アイ" }, { w: "was", r: "ワズ" }, { w: "returning", r: "リターニング" }, { w: "to", r: "トゥ", s: true }, 
      { w: "my", r: "マイ" }, { w: "much", r: "マッチ" }, { w: "smaller", r: "スモーラー" }, { w: "self.", r: "セルフ", s: true }
    ],
    en: "Every time the scissors moved,\nthe chains in my body untied.\nMy shape changed little by little.\nBut, it was strange.\nI did not feel bad.\nRather, it was somewhat nostalgic.\nIt felt like I was returning to\nmy much smaller self.",
    ja: "ハサミが動くたび、\nぼくの体の中の鎖がほどけていく。\n形は少しずつ変わっていく。\nでも、不思議だった。\n嫌な気持ちはしない。\nむしろどこか懐かしい。\nまるで、もっと小さかった頃の\nぼくに戻っていくような気がした。",
    learning: {
      vocab: [
        { word: "Every time ~", mean: "〜するたびに" },
        { word: "little by little", mean: "少しずつ" },
        { word: "rather", mean: "むしろ" },
        { word: "somewhat", mean: "いくぶん、どこか" },
        { word: "nostalgic", mean: "懐かしい" },
        { word: "return", mean: "戻る" }
      ],
      grammar: {
        title: "feel like + 文",
        desc: "「まるで〜のような気がする」という例えを表します。",
        key: "It felt like I was returning to..."
      }
    },
    color: "bg-pink-50", accent: "text-pink-600", mood: { rate: 0.9, pitch: 1.0 }, image: "images/006/07.jpg", startTime: 120
  },
  {
    title: "Part 2: The Transformation Ritual (4/4)",
    rubyText: [
      { w: "Amylase", r: "アミラーゼ" }, { w: "nodded", r: "ノディッド" }, { w: "quietly.", r: "クワイエットリー", s: true }, 
      { w: "\"Yes.", r: "イエス", s: true }, 
      { w: "You", r: "ユー" }, { w: "are", r: "アー" }, { w: "not", r: "ノット" }, { w: "just", r: "ジャスト" }, { w: "a", r: "ア" }, { w: "taiyaki", r: "タイヤキ" }, { w: "anymore.\"", r: "エニモア", s: true }, 
      { w: "\"Now,", r: "ナウ", s: true }, { w: "to", r: "トゥ" }, { w: "a", r: "ア" }, { w: "deeper", r: "ディーパー" }, { w: "place.\"", r: "プレイス", s: true }, 
      { w: "\"Your", r: "ユア" }, { w: "real", r: "リアル" }, { w: "journey", r: "ジャーニー" }, { w: "begins", r: "ビギンズ" }, { w: "now.\"", r: "ナウ", s: true }
    ],
    en: "Amylase nodded quietly.\n\"Yes.\nYou are not just a taiyaki anymore.\"\n\"Now, to a deeper place.\"\n\"Your real journey begins now.\"",
    ja: "アミラーゼは静かにうなずいた。\n「ええ。\nあなたはもう、ただの“たいやき”じゃない。」\n「さあ、もっと深い場所へ。」\n「本当の旅は、これから始まるのよ。」",
    learning: {
      vocab: [
        { word: "nod", mean: "うなずく" },
        { word: "not just ~", mean: "ただの〜ではない" },
        { word: "deeper", mean: "より深い（deepの比較級）" },
        { word: "journey", mean: "旅" }
      ],
      grammar: {
        title: "not ~ anymore",
        desc: "「もはや〜ではない、もう〜ではない」と状態が変わったことを示します。",
        key: "You are not just a taiyaki anymore."
      }
    },
    color: "bg-purple-50", accent: "text-purple-600", mood: { rate: 0.95, pitch: 1.1 }, image: "images/006/08.jpg", startTime: 140
  },

  // ==========================================
  // Part 3
  // ==========================================
  {
    title: "Part 3: The Dark Slide (1/4)",
    rubyText: [
      { w: "Seen", r: "シーン" }, { w: "off", r: "オフ" }, { w: "by", r: "バイ" }, { w: "Amylase,", r: "アミラーゼ", s: true }, 
      { w: "I", r: "アイ" }, { w: "was", r: "ワズ" }, { w: "washed", r: "ウォッシュト" }, { w: "into", r: "イントゥ" }, { w: "a", r: "ア" }, { w: "dark", r: "ダーク" }, { w: "passage.", r: "パッセージ", s: true }, 
      { w: "It", r: "イット" }, { w: "was", r: "ワズ" }, { w: "like", r: "ライク", s: true }, { w: "a", r: "ア" }, { w: "dark", r: "ダーク" }, { w: "slide.", r: "スライド", s: true }, 
      { w: "Long,", r: "ロング", s: true }, { w: "dark,", r: "ダーク", s: true }, { w: "and", r: "アンド" }, { w: "unstoppable.", r: "アンストッパブル", s: true }, 
      { w: "The", r: "ザ" }, { w: "walls", r: "ウォールズ" }, { w: "moved", r: "ムーブド" }, { w: "slowly,", r: "スローリー", s: true }, 
      { w: "pushing", r: "プッシング" }, { w: "me", r: "ミー" }, { w: "down", r: "ダウン" }, { w: "and", r: "アンド" }, { w: "down.", r: "ダウン", s: true }, 
      { w: "\"Waaaa...!\"", r: "ワァー", s: true }, 
      { w: "I", r: "アイ" }, { w: "shouted.", r: "シャウティッド", s: true }
    ],
    en: "Seen off by Amylase,\nI was washed into a dark passage.\nIt was like a dark slide.\nLong, dark, and unstoppable.\nThe walls moved slowly,\npushing me down and down.\n\"Waaaa...!\"\nI shouted.",
    ja: "アミラーゼに見送られ、\nぼくは暗い通路へと押し流された。\nそこは、まるで暗黒の滑り台だった。\n長くて、暗くて、止まらない。\n壁がゆっくり動き、\nぼくを下へ、下へと押し出していく。\n「うわあああ……！」\nぼくは叫んだ。",
    learning: {
      vocab: [
        { word: "see off", mean: "見送る" },
        { word: "passage", mean: "通路" },
        { word: "unstoppable", mean: "止まらない、抑えられない" },
        { word: "shout", mean: "叫ぶ" }
      ],
      grammar: {
        title: "分詞構文 (過去分詞から始まる文)",
        desc: "「Seen off by~（〜に見送られて）」のように、過去分詞で文を始めることで、主語の状況や理由を簡潔に補足します。",
        key: "Seen off by Amylase, I was washed into..."
      }
    },
    color: "bg-indigo-900", accent: "text-indigo-200", mood: { rate: 1.0, pitch: 0.8 }, image: "images/006/09.jpg", startTime: 160
  },
  {
    title: "Part 3: The Dark Slide (2/4)",
    rubyText: [
      { w: "But", r: "バット", s: true }, { w: "the", r: "ザ" }, { w: "flow", r: "フロウ" }, { w: "did", r: "ディド" }, { w: "not", r: "ノット" }, { w: "stop.", r: "ストップ", s: true }, 
      { w: "I", r: "アイ" }, { w: "could", r: "クッド" }, { w: "not", r: "ノット" }, { w: "go", r: "ゴー" }, { w: "back,", r: "バック", s: true }, { w: "either.", r: "イーザー", s: true }, 
      { w: "I", r: "アイ" }, { w: "was", r: "ワズ" }, { w: "carried", r: "キャリード" }, { w: "deeper", r: "ディーパー" }, { w: "and", r: "アンド" }, { w: "deeper.", r: "ディーパー", s: true }, 
      { w: "Just", r: "ジャスト" }, { w: "then,", r: "ゼン", s: true }, { w: "a", r: "ア" }, { w: "voice", r: "ボイス" }, { w: "echoed", r: "エコウド" }, { w: "in", r: "イン" }, { w: "the", r: "ザ" }, { w: "dark.", r: "ダーク", s: true }, 
      { w: "\"...A", r: "ア", s: true }, { w: "newcomer?\"", r: "ニューカマー", s: true }, { w: "It", r: "イット" }, { w: "was", r: "ワズ" }, { w: "a", r: "ア" }, { w: "low", r: "ロウ" }, { w: "voice.", r: "ボイス", s: true }, 
      { w: "\"Wh-Who", r: "フー" }, { w: "is", r: "イズ" }, { w: "it!\"", r: "イット", s: true }, { w: "I", r: "アイ" }, { w: "shouted.", r: "シャウティッド", s: true }, 
      { w: "But", r: "バット", s: true }, { w: "there", r: "ゼア" }, { w: "was", r: "ワズ" }, { w: "no", r: "ノー" }, { w: "answer.", r: "アンサー", s: true }, 
      { w: "The", r: "ザ" }, { w: "slide", r: "スライド" }, { w: "still", r: "スティル" }, { w: "continued.", r: "コンティニュード", s: true }
    ],
    en: "But the flow did not stop.\nI could not go back, either.\nI was carried deeper and deeper.\nJust then, a voice echoed in the dark.\n\"...A newcomer?\" It was a low voice.\n\"Wh-Who is it!\" I shouted.\nBut there was no answer.\nThe slide still continued.",
    ja: "でも流れは止まらない。\n後ろへ戻ることもできない。\nどんどん奥へ運ばれていく。\nそのとき、暗闇の中で声が響いた。\n「……新入りか。」低い声だった。\n「だ、だれ！」ぼくは叫んだ。\nけれど返事はない。滑り台はまだ続いている。",
    learning: {
      vocab: [
        { word: "flow", mean: "流れ" },
        { word: "carry", mean: "運ぶ" },
        { word: "echo", mean: "反響する、響く" },
        { word: "newcomer", mean: "新入り" },
        { word: "continue", mean: "続く" }
      ],
      grammar: {
        title: "否定文 + either",
        desc: "「〜もまた（ない）」と同調する否定の意味を表します。",
        key: "I could not go back, either."
      }
    },
    color: "bg-slate-800", accent: "text-slate-300", mood: { rate: 0.9, pitch: 0.7 }, image: "images/006/10.jpg", startTime: 180
  },
  {
    title: "Part 3: The Dark Slide (3/4)",
    rubyText: [
      { w: "And", r: "アンド" }, { w: "suddenly--", r: "サドゥンリー", s: true }, 
      { w: "my", r: "マイ" }, { w: "view", r: "ビュー" }, { w: "opened", r: "オープンド" }, { w: "wide.", r: "ワイド", s: true }, 
      { w: "My", r: "マイ" }, { w: "body", r: "ボディ" }, { w: "fell", r: "フェル" }, { w: "straight", r: "ストレイト" }, { w: "into", r: "イントゥ" }, { w: "liquid.", r: "リキッド", s: true }, 
      { w: "Splash.", r: "スプラッシュ", s: true }, 
      { w: "But", r: "バット", s: true }, { w: "there", r: "ゼア" }, { w: "was", r: "ワズ" }, { w: "no", r: "ノー" }, { w: "refreshing", r: "リフレッシング" }, { w: "feeling", r: "フィーリング", s: true }, 
      { w: "like", r: "ライク", s: true }, { w: "the", r: "ザ" }, { w: "sea.", r: "シー", s: true }, 
      { w: "It", r: "イット" }, { w: "was", r: "ワズ" }, { w: "thick", r: "シック" }, { w: "and", r: "アンド" }, { w: "gooey.", r: "グーイー", s: true }
    ],
    en: "And suddenly--\nmy view opened wide.\nMy body fell straight into liquid.\nSplash.\nBut there was no refreshing feeling\nlike the sea.\nIt was thick and gooey.",
    ja: "そして突然――\n視界が大きく開けた。\nぼくの体は、そのまま液体の中へ落ちた。\nドボン。\nだけど海のような爽快さはない。\nドロドロしている。",
    learning: {
      vocab: [
        { word: "view", mean: "視界、景色" },
        { word: "straight", mean: "まっすぐに" },
        { word: "liquid", mean: "液体" },
        { word: "refreshing", mean: "爽快な、さわやかな" },
        { word: "thick", mean: "とろみのある、濃い" },
        { word: "gooey", mean: "ドロドロした、ネバネバした" }
      ],
      grammar: {
        title: "no + 名詞",
        desc: "「全く〜ない」と強い否定を表します。「no refreshing feeling」で「爽快感は全くない」となります。",
        key: "there was no refreshing feeling..."
      }
    },
    color: "bg-emerald-900", accent: "text-emerald-200", mood: { rate: 0.85, pitch: 0.8 }, image: "images/006/11.jpg", startTime: 200
  },
  {
    title: "Part 3: The Dark Slide (4/4)",
    rubyText: [
      { w: "Moreover,", r: "モアオーバー", s: true }, { w: "it", r: "イット" }, { w: "was", r: "ワズ" }, { w: "very", r: "ベリー" }, { w: "hot.", r: "ホット", s: true }, 
      { w: "The", r: "ザ" }, { w: "liquid", r: "リキッド" }, { w: "soaked", r: "ソークト" }, { w: "deep", r: "ディープ" }, { w: "into", r: "イントゥ" }, { w: "my", r: "マイ" }, { w: "body.", r: "ボディ", s: true }, 
      { w: "The", r: "ザ" }, { w: "place", r: "プレイス" }, { w: "I", r: "アイ" }, { w: "finally", r: "ファイナリー" }, { w: "reached", r: "リーチト", s: true }, { w: "was", r: "ワズ", s: true }, 
      { w: "the", r: "ザ" }, { w: "Acid", r: "アシッド" }, { w: "Lake,", r: "レイク", s: true }, { w: "which", r: "ウィッチ" }, { w: "melts", r: "メルツ" }, { w: "everything.", r: "エブリシング", s: true }
    ],
    en: "Moreover, it was very hot.\nThe liquid soaked deep into my body.\nThe place I finally reached was\nthe Acid Lake, which melts everything.",
    ja: "しかも、とても熱い。\n液体は体の奥まで染み込んでくる。\nようやく辿り着いたそこは、\nすべてを溶かす 酸の湖 だった。",
    learning: {
      vocab: [
        { word: "moreover", mean: "その上、しかも" },
        { word: "soak", mean: "染み込む、浸す" },
        { word: "reach", mean: "辿り着く、到達する" },
        { word: "acid", mean: "酸" },
        { word: "melt", mean: "溶かす" }
      ],
      grammar: {
        title: "関係代名詞の非制限用法 (, which)",
        desc: "名詞（The Acid Lake）の後にカンマを置き、補足的な説明を追加します。",
        key: "...the Acid Lake, which melts everything."
      }
    },
    color: "bg-teal-900", accent: "text-teal-200", mood: { rate: 0.9, pitch: 0.9 }, image: "images/006/12.jpg", startTime: 220
  },

  // ==========================================
  // Part 4
  // ==========================================
  {
    title: "Part 4: Reunion (1/3)",
    rubyText: [
      { w: "My", r: "マイ" }, { w: "consciousness", r: "コンシャスネス" }, { w: "was", r: "ワズ" }, { w: "fading", r: "フェイディング" }, { w: "away.", r: "アウェイ", s: true }, 
      { w: "Someone", r: "サムワン" }, { w: "grabbed", r: "グラブド" }, { w: "my", r: "マイ" }, { w: "body", r: "ボディ" }, { w: "strongly.", r: "ストロングリー", s: true }, 
      { w: "\"Hey.", r: "ヘイ", s: true }, { w: "Pull", r: "プル" }, { w: "yourself", r: "ユアセルフ" }, { w: "together.\"", r: "トゥゲザー", s: true }, 
      { w: "It", r: "イット" }, { w: "was", r: "ワズ" }, { w: "a", r: "ア" }, { w: "familiar", r: "ファミリア" }, { w: "voice.", r: "ボイス", s: true }, 
      { w: "\"If", r: "イフ" }, { w: "you", r: "ユー" }, { w: "pass", r: "パス" }, { w: "out", r: "アウト" }, { w: "here,", r: "ヒア", s: true }, 
      { w: "you", r: "ユー" }, { w: "will", r: "ウィル" }, { w: "just", r: "ジャスト" }, { w: "melt", r: "メルト" }, { w: "and", r: "アンド" }, { w: "disappear.\"", r: "ディスアピアー", s: true }, 
      { w: "I", r: "アイ" }, { w: "slowly", r: "スローリー" }, { w: "opened", r: "オープンド" }, { w: "my", r: "マイ" }, { w: "eyes.", r: "アイズ", s: true }, 
      { w: "\"Sardine-senpai!\"", r: "サーディン・センパイ", s: true }
    ],
    en: "My consciousness was fading away.\nSomeone grabbed my body strongly.\n\"Hey. Pull yourself together.\"\nIt was a familiar voice.\n\"If you pass out here,\nyou will just melt and disappear.\"\nI slowly opened my eyes.\n\"Sardine-senpai!\"",
    ja: "意識が遠のきかけた、そのときだった。\n誰かがぼくの体を強くつかんだ。\n「おい。しっかりしろ。」\n聞き覚えのある声だった。\n「ここで気を失えば、\nただ溶けて消えるだけだぞ。」\nぼくはゆっくり目を開けた。\n「イワシ先輩！」",
    learning: {
      vocab: [
        { word: "consciousness", mean: "意識" },
        { word: "fade away", mean: "薄れる、消えていく" },
        { word: "grab", mean: "つかむ" },
        { word: "familiar", mean: "聞き覚えのある、見慣れた" },
        { word: "pass out", mean: "気を失う、気絶する" },
        { word: "disappear", mean: "消える" }
      ],
      grammar: {
        title: "熟語: Pull yourself together",
        desc: "「気を取り直す、しっかりする」という意味のよく使われる決まり文句です。",
        key: "Pull yourself together."
      }
    },
    color: "bg-blue-100", accent: "text-blue-700", mood: { rate: 0.95, pitch: 0.9 }, image: "images/006/13.jpg", startTime: 240
  },
  {
    title: "Part 4: Reunion (2/3)",
    rubyText: [
      { w: "The", r: "ザ" }, { w: "one", r: "ワン", s: true }, { w: "who", r: "フー" }, { w: "was", r: "ワズ" }, { w: "there", r: "ゼア", s: true }, { w: "was", r: "ワズ" }, { w: "the", r: "ザ" }, { w: "Sardine", r: "サーディン", s: true }, 
      { w: "I", r: "アイ" }, { w: "swam", r: "スワム" }, { w: "with", r: "ウィズ" }, { w: "in", r: "イン" }, { w: "the", r: "ザ" }, { w: "sea.", r: "シー", s: true }, 
      { w: "The", r: "ザ" }, { w: "bubbles", r: "バブルズ" }, { w: "of", r: "オブ" }, { w: "the", r: "ザ" }, { w: "acid", r: "アシッド" }, { w: "lake", r: "レイク", s: true }, { w: "were", r: "ワー", s: true }, 
      { w: "popping", r: "ポッピング" }, { w: "quietly", r: "クワイエットリー" }, { w: "around", r: "アラウンド" }, { w: "his", r: "ヒズ" }, { w: "body.", r: "ボディ", s: true }, 
      { w: "I", r: "アイ" }, { w: "realized", r: "リアライズド" }, { w: "that", r: "ザット", s: true }, { w: "this", r: "ディス" }, { w: "place", r: "プレイス" }, { w: "was", r: "ワズ" }, { w: "melting", r: "メルティング", s: true }, 
      { w: "us", r: "アス" }, { w: "little", r: "リトル" }, { w: "by", r: "バイ" }, { w: "little.", r: "リトル", s: true }, 
      { w: "\"Were", r: "ワー" }, { w: "you", r: "ユー" }, { w: "eaten", r: "イートン" }, { w: "too...", r: "トゥー", s: true }, { w: "senpai?\"", r: "センパイ", s: true }, 
      { w: "He", r: "ヒー" }, { w: "shrugged.", r: "シュラッグド", s: true }, { w: "\"Well,", r: "ウェル", s: true }, { w: "it", r: "イット" }, { w: "is", r: "イズ" }, { w: "destiny.\"", r: "デスティニー", s: true }
    ],
    en: "The one who was there was the Sardine\nI swam with in the sea.\nThe bubbles of the acid lake were\npopping quietly around his body.\nI realized that this place was melting\nus little by little.\n\"Were you eaten too... senpai?\"\nHe shrugged. \"Well, it is destiny.\"",
    ja: "そこにいたのは、\n海で一緒に泳いでいたイワシ先輩だった。\n酸の湖の泡が、\n先輩の体のまわりで静かにはじけていた。\nこの場所が、\nぼくらを少しずつ溶かしているのが分かった。\n「先輩も……食べられたの？」\n先輩は肩をすくめた。「まあ、運命ってやつさ。」",
    learning: {
      vocab: [
        { word: "sardine", mean: "イワシ" },
        { word: "bubble", mean: "泡" },
        { word: "pop", mean: "（泡が）はじける" },
        { word: "realize", mean: "気づく、理解する" },
        { word: "shrug", mean: "肩をすくめる" },
        { word: "destiny", mean: "運命" }
      ],
      grammar: {
        title: "関係代名詞 who",
        desc: "「The one who was there（そこにいた人＝者）」のように、前の名詞（The one）を修飾します。",
        key: "The one who was there was the Sardine..."
      }
    },
    color: "bg-sky-100", accent: "text-sky-700", mood: { rate: 0.9, pitch: 0.95 }, image: "images/006/14.jpg", startTime: 260
  },
  {
    title: "Part 4: Reunion (3/3)",
    rubyText: [
      { w: "I", r: "アイ" }, { w: "looked", r: "ルックト" }, { w: "at", r: "アット" }, { w: "his", r: "ヒズ" }, { w: "body", r: "ボディ", s: true }, { w: "and", r: "アンド" }, { w: "gasped.", r: "ガスプト", s: true }, 
      { w: "His", r: "ヒズ" }, { w: "silver", r: "シルバー" }, { w: "body", r: "ボディ", s: true }, { w: "was", r: "ワズ" }, { w: "starting", r: "スターティング" }, { w: "to", r: "トゥ" }, { w: "crumble.", r: "クランブル", s: true }, 
      { w: "It", r: "イット" }, { w: "wasn't", r: "ワズント" }, { w: "the", r: "ザ" }, { w: "proud", r: "プラウド" }, { w: "figure", r: "フィギュア", s: true }, { w: "from", r: "フロム" }, { w: "the", r: "ザ" }, { w: "sea.", r: "シー", s: true }, 
      { w: "Still,", r: "スティル", s: true }, { w: "he", r: "ヒー" }, { w: "said", r: "セッド" }, { w: "in", r: "イン" }, { w: "a", r: "ア" }, { w: "calm", r: "カーム" }, { w: "voice.", r: "ボイス", s: true }, 
      { w: "\"Don't", r: "ドント" }, { w: "be", r: "ビー" }, { w: "surprised.", r: "サプライズド", s: true }, { w: "We", r: "ウィ" }, { w: "are", r: "アー" }, { w: "all", r: "オール", s: true }, 
      { w: "the", r: "ザ" }, { w: "same", r: "セイム" }, { w: "here.\"", r: "ヒア", s: true }, { w: "He", r: "ヒー" }, { w: "looked", r: "ルックト" }, { w: "right", r: "ライト" }, { w: "at", r: "アット" }, { w: "me.", r: "ミー", s: true }, 
      { w: "\"But", r: "バット", s: true }, { w: "Taiyaki,", r: "タイヤキ", s: true }, { w: "we", r: "ウィ" }, { w: "didn't", r: "ディドゥント" }, { w: "come", r: "カム" }, { w: "here", r: "ヒア", s: true }, 
      { w: "just", r: "ジャスト" }, { w: "to", r: "トゥ" }, { w: "disappear.\"", r: "ディスアピアー", s: true }
    ],
    en: "I looked at his body and gasped.\nHis silver body was starting to crumble.\nIt wasn't the proud figure from the sea.\nStill, he said in a calm voice.\n\"Don't be surprised. We are all\nthe same here.\" He looked right at me.\n\"But Taiyaki, we didn't come here\njust to disappear.\"",
    ja: "ぼくは先輩の体を見て、はっとした。\n銀色の体が、少しずつ崩れはじめている。\n海で見た、あの立派な姿とは違う。\nそれでも先輩は落ち着いた声で言った。\n「驚くな。ここではみんな同じだ。」\nそして、ぼくをまっすぐ見た。\n「だがな、たいやき。」\n「俺たちは消えるためだけにここへ来たんじゃない。」",
    learning: {
      vocab: [
        { word: "gasp", mean: "はっと息をのむ" },
        { word: "crumble", mean: "崩れる、砕ける" },
        { word: "proud", mean: "誇り高い、立派な" },
        { word: "figure", mean: "姿、形" },
        { word: "calm", mean: "落ち着いた" }
      ],
      grammar: {
        title: "副詞的用法の不定詞 (to + 動詞)",
        desc: "「〜するために」と目的を表します。「just to disappear」で「ただ消えるためだけに」という意味になります。",
        key: "we didn't come here just to disappear."
      }
    },
    color: "bg-cyan-100", accent: "text-cyan-700", mood: { rate: 0.9, pitch: 0.95 }, image: "images/006/15.jpg", startTime: 280
  },

  // ==========================================
  // Part 5
  // ==========================================
  {
    title: "Part 5: The Acid Lake (1/4)",
    rubyText: [
      { w: "Just", r: "ジャスト" }, { w: "then,", r: "ゼン", s: true }, { w: "a", r: "ア" }, { w: "voice", r: "ボイス" }, { w: "echoed", r: "エコウド" }, { w: "from", r: "フロム", s: true }, 
      { w: "deep", r: "ディープ" }, { w: "within", r: "ウィズイン" }, { w: "the", r: "ザ" }, { w: "lake.", r: "レイク", s: true }, { w: "\"...A", r: "ア", s: true }, { w: "newcomer?\"", r: "ニューカマー", s: true }, 
      { w: "It", r: "イット" }, { w: "was", r: "ワズ" }, { w: "the", r: "ザ" }, { w: "voice", r: "ボイス" }, { w: "from", r: "フロム" }, { w: "before.", r: "ビフォア", s: true }, 
      { w: "Beyond", r: "ビヨンド" }, { w: "the", r: "ザ" }, { w: "fog,", r: "フォグ", s: true }, { w: "a", r: "ア" }, { w: "thin", r: "シン" }, { w: "man", r: "マン" }, { w: "was", r: "ワズ" }, { w: "standing.", r: "スタンディング", s: true }, 
      { w: "He", r: "ヒー" }, { w: "stood", r: "ストゥッド" }, { w: "quietly", r: "クワイエットリー" }, { w: "on", r: "オン" }, { w: "the", r: "ザ" }, { w: "acid", r: "アシッド" }, { w: "lake,", r: "レイク", s: true }, 
      { w: "as", r: "アズ" }, { w: "if", r: "イフ", s: true }, { w: "stepping", r: "ステッピング" }, { w: "on", r: "オン" }, { w: "the", r: "ザ" }, { w: "water's", r: "ウォーターズ" }, { w: "surface.", r: "サーフェス", s: true }
    ],
    en: "Just then, a voice echoed from\ndeep within the lake. \"...A newcomer?\"\nIt was the voice from before.\nBeyond the fog, a thin man was standing.\nHe stood quietly on the acid lake,\nas if stepping on the water's surface.",
    ja: "そのとき、湖の奥から声が響いた。\n「……新入りか。」\nあの時の声だ。\n霧の向こうに、細身の男が立っていた。\n酸の湖の上に、\nまるで水面を踏むように静かに立っている。",
    learning: {
      vocab: [
        { word: "deep within", mean: "〜の奥深くから" },
        { word: "beyond", mean: "〜の向こうに" },
        { word: "thin", mean: "細身の、痩せた" },
        { word: "step", mean: "歩む、踏む" },
        { word: "surface", mean: "表面、水面" }
      ],
      grammar: {
        title: "as if ~",
        desc: "「まるで〜かのように」という意味で、実際とは違う様子を例える表現です。",
        key: "as if stepping on the water's surface."
      }
    },
    color: "bg-emerald-100", accent: "text-emerald-700", mood: { rate: 0.9, pitch: 0.85 }, image: "images/006/16.jpg", startTime: 300
  },
  {
    title: "Part 5: The Acid Lake (2/4)",
    rubyText: [
      { w: "Here", r: "ヒア" }, { w: "and", r: "アンド" }, { w: "there", r: "ゼア" }, { w: "in", r: "イン" }, { w: "the", r: "ザ" }, { w: "lake,", r: "レイク", s: true }, { w: "half-melted", r: "ハーフ・メルティッド", s: true }, 
      { w: "foods", r: "フーズ" }, { w: "were", r: "ワー" }, { w: "sinking", r: "シンキング" }, { w: "slowly.", r: "スローリー", s: true }, 
      { w: "Sometimes", r: "サムタイムズ", s: true }, { w: "bubbles", r: "バブルズ" }, { w: "floated", r: "フローティッド" }, { w: "up,", r: "アップ", s: true }, 
      { w: "and", r: "アンド" }, { w: "the", r: "ザ" }, { w: "acid", r: "アシッド" }, { w: "fog", r: "フォグ" }, { w: "rose", r: "ローズ" }, { w: "quietly.", r: "クワイエットリー", s: true }, 
      { w: "Here,", r: "ヒア", s: true }, { w: "the", r: "ザ" }, { w: "shapes", r: "シェイプス" }, { w: "of", r: "オブ" }, { w: "living", r: "リビング" }, { w: "things", r: "シングス", s: true }, 
      { w: "unraveled.", r: "アンラヴェルド", s: true }, { w: "The", r: "ザ" }, { w: "man's", r: "マンズ" }, { w: "white", r: "ホワイト" }, { w: "fingers", r: "フィンガーズ", s: true }, 
      { w: "moved", r: "ムーブド" }, { w: "slowly.", r: "スローリー", s: true }, { w: "Then", r: "ゼン", s: true }, { w: "the", r: "ザ" }, { w: "lake", r: "レイク" }, { w: "shook,", r: "シュック", s: true }, 
      { w: "and", r: "アンド" }, { w: "heavy", r: "ヘビー" }, { w: "waves", r: "ウェーブス" }, { w: "spread.", r: "スプレッド", s: true }
    ],
    en: "Here and there in the lake, half-melted\nfoods were sinking slowly.\nSometimes bubbles floated up,\nand the acid fog rose quietly.\nHere, the shapes of living things\nunraveled. The man's white fingers\nmoved slowly. Then the lake shook,\nand heavy waves spread.",
    ja: "湖のあちこちでは、\nまだ溶けきらない食べ物たちがゆっくり沈んでいた。\nときどき泡が浮かび上がり、\n酸の霧が静かに立ちのぼる。\nここは、生き物の形がほどけていく場所だった。\n男の白い指がゆっくり動く。\nすると湖面が揺れ、重たい波が広がった。",
    learning: {
      vocab: [
        { word: "Here and there", mean: "あちこちに" },
        { word: "half-melted", mean: "半分溶けた" },
        { word: "float up", mean: "浮かび上がる" },
        { word: "unravel", mean: "ほどける、解明される" },
        { word: "shake", mean: "揺れる（過去形: shook）" },
        { word: "spread", mean: "広がる" }
      ],
      grammar: {
        title: "過去進行形 (were + -ing)",
        desc: "過去のある時点で進行中だった動作を表します。「were sinking（沈みつつあった）」となります。",
        key: "...foods were sinking slowly."
      }
    },
    color: "bg-emerald-200", accent: "text-emerald-800", mood: { rate: 0.9, pitch: 0.8 }, image: "images/006/17.jpg", startTime: 320
  },
  {
    title: "Part 5: The Acid Lake (3/4)",
    rubyText: [
      { w: "\"I", r: "アイ" }, { w: "am", r: "アム" }, { w: "Pepsin,\"", r: "ペプシン", s: true }, 
      { w: "the", r: "ザ" }, { w: "man", r: "マン" }, { w: "said", r: "セッド" }, { w: "quietly.", r: "クワイエットリー", s: true }, 
      { w: "\"This", r: "ディス" }, { w: "is", r: "イズ" }, { w: "the", r: "ザ" }, { w: "stomach.", r: "ストマック", s: true }, 
      { w: "An", r: "アン" }, { w: "acid", r: "アシッド" }, { w: "lake", r: "レイク" }, { w: "that", r: "ザット", s: true }, { w: "melts", r: "メルツ" }, { w: "everything.\"", r: "エブリシング", s: true }, 
      { w: "The", r: "ザ" }, { w: "waves", r: "ウェーブス" }, { w: "spread", r: "スプレッド" }, { w: "slowly,", r: "スローリー", s: true }, 
      { w: "and", r: "アンド" }, { w: "the", r: "ザ" }, { w: "surface", r: "サーフェス" }, { w: "of", r: "オブ" }, { w: "the", r: "ザ" }, { w: "lake", r: "レイク" }, { w: "swelled.", r: "スウェルド", s: true }, 
      { w: "\"Here,", r: "ヒア", s: true }, { w: "meat,", r: "ミート", s: true }, { w: "bones,", r: "ボーンズ", s: true }, { w: "shells,", r: "シェルズ", s: true }, 
      { w: "everything", r: "エブリシング" }, { w: "melts.\"", r: "メルツ", s: true }
    ],
    en: "\"I am Pepsin,\"\nthe man said quietly.\n\"This is the stomach.\nAn acid lake that melts everything.\"\nThe waves spread slowly,\nand the surface of the lake swelled.\n\"Here, meat, bones, shells,\neverything melts.\"",
    ja: "「私はペプシン。」\n男は静かに言った。\n「ここは“胃”。すべてを溶かす酸の湖だ。」\n波がゆっくりと広がり、湖の表面がうねる。\n「ここでは、肉も、骨も、殻も、すべて溶けていく。」",
    learning: {
      vocab: [
        { word: "stomach", mean: "胃" },
        { word: "swell", mean: "うねる、膨らむ" },
        { word: "meat", mean: "肉" },
        { word: "bone", mean: "骨" },
        { word: "shell", mean: "殻" }
      ],
      grammar: {
        title: "関係代名詞 that",
        desc: "前の名詞（lake）を修飾し、「すべてを溶かす酸の湖」という意味を作ります。",
        key: "An acid lake that melts everything."
      }
    },
    color: "bg-teal-100", accent: "text-teal-800", mood: { rate: 0.95, pitch: 0.8 }, image: "images/006/18.jpg", startTime: 340
  },
  {
    title: "Part 5: The Acid Lake (4/4)",
    rubyText: [
      { w: "Pepsin", r: "ペプシン" }, { w: "looked", r: "ルックト" }, { w: "down", r: "ダウン" }, { w: "at", r: "アット" }, { w: "me.", r: "ミー", s: true }, 
      { w: "His", r: "ヒズ" }, { w: "eyes", r: "アイズ" }, { w: "were", r: "ワー" }, { w: "cold", r: "コールド", s: true }, { w: "like", r: "ライク" }, { w: "the", r: "ザ" }, { w: "lake", r: "レイク" }, { w: "itself.", r: "イットセルフ", s: true }, 
      { w: "\"Everyone", r: "エブリワン" }, { w: "who", r: "フー" }, { w: "comes", r: "カムズ" }, { w: "here", r: "ヒア", s: true }, 
      { w: "shares", r: "シェアーズ" }, { w: "the", r: "ザ" }, { w: "same", r: "セイム" }, { w: "destiny.\"", r: "デスティニー", s: true }, 
      { w: "When", r: "ウェン", s: true }, { w: "he", r: "ヒー" }, { w: "moved", r: "ムーブド" }, { w: "his", r: "ヒズ" }, { w: "fingers,", r: "フィンガーズ", s: true }, 
      { w: "the", r: "ザ" }, { w: "waves", r: "ウェーブス" }, { w: "of", r: "オブ" }, { w: "the", r: "ザ" }, { w: "lake", r: "レイク" }, { w: "grew", r: "グルー" }, { w: "even", r: "イーブン" }, { w: "larger.", r: "ラージャー", s: true }, 
      { w: "The", r: "ザ" }, { w: "acid", r: "アシッド" }, { w: "fog", r: "フォグ" }, { w: "spread", r: "スプレッド" }, { w: "slowly,", r: "スローリー", s: true }, 
      { w: "enveloping", r: "エンベローピング" }, { w: "my", r: "マイ" }, { w: "body.", r: "ボディ", s: true }
    ],
    en: "Pepsin looked down at me.\nHis eyes were cold like the lake itself.\n\"Everyone who comes here\nshares the same destiny.\"\nWhen he moved his fingers,\nthe waves of the lake grew even larger.\nThe acid fog spread slowly,\nenveloping my body.",
    ja: "ペプシンはぼくを見下ろした。\nその目は、まるでこの湖そのもののように冷たい。\n「ここに来たものは、みんな同じ運命だ。」\n彼が指を動かすと、湖の波はさらに大きくなった。\n酸の霧がゆっくり広がり、\nぼくの体を包み込んでいった。",
    learning: {
      vocab: [
        { word: "look down at ~", mean: "〜を見下ろす" },
        { word: "itself", mean: "それ自体" },
        { word: "share", mean: "共有する、共にする" },
        { word: "grow", mean: "（状態に）なる（過去形: grew）" },
        { word: "envelop", mean: "包み込む" }
      ],
      grammar: {
        title: "比較級の強調 (even + 比較級)",
        desc: "「even larger」で、「さらに大きい、いっそう大きい」と比較の意味を強めます。",
        key: "...the waves of the lake grew even larger."
      }
    },
    color: "bg-cyan-900", accent: "text-cyan-200", mood: { rate: 0.95, pitch: 0.7 }, image: "images/006/19.jpg", startTime: 360
  },

  // ==========================================
  // Part 6
  // ==========================================
  {
    title: "Part 6: Beyond That (1/4)",
    rubyText: [
      { w: "\"Don't", r: "ドント" }, { w: "worry,\"", r: "ウォーリー", s: true }, { w: "the", r: "ザ" }, { w: "Sardine", r: "サーディン" }, { w: "said.", r: "セッド", s: true }, 
      { w: "\"Melting", r: "メルティング" }, { w: "is", r: "イズ" }, { w: "not", r: "ノット" }, { w: "the", r: "ザ" }, { w: "end.", r: "エンド", s: true }, 
      { w: "It", r: "イット" }, { w: "is", r: "イズ" }, { w: "preparation", r: "プレパレーション" }, { w: "for", r: "フォー" }, { w: "the", r: "ザ" }, { w: "next", r: "ネクスト" }, { w: "step.\"", r: "ステップ", s: true }, 
      { w: "I", r: "アイ" }, { w: "shook", r: "シュック" }, { w: "my", r: "マイ" }, { w: "head.", r: "ヘッド", s: true }, { w: "\"What", r: "ホワット" }, { w: "do", r: "ドゥ" }, { w: "you", r: "ユー" }, { w: "mean?\"", r: "ミーン", s: true }, 
      { w: "He", r: "ヒー" }, { w: "smiled", r: "スマイルド" }, { w: "a", r: "ア" }, { w: "little.", r: "リトル", s: true }, 
      { w: "\"I", r: "アイ" }, { w: "finish", r: "フィニッシュ" }, { w: "my", r: "マイ" }, { w: "role", r: "ロール" }, { w: "here.", r: "ヒア", s: true }, 
      { w: "I", r: "アイ" }, { w: "will", r: "ウィル" }, { w: "melt", r: "メルト" }, { w: "here,", r: "ヒア", s: true }, 
      { w: "and", r: "アンド" }, { w: "become", r: "ビカム" }, { w: "the", r: "ザ" }, { w: "man's", r: "マンズ" }, { w: "power.\"", r: "パワー", s: true }
    ],
    en: "\"Don't worry,\" the Sardine said.\n\"Melting is not the end.\nIt is preparation for the next step.\"\nI shook my head. \"What do you mean?\"\nHe smiled a little.\n\"I finish my role here.\nI will melt here,\nand become the man's power.\"",
    ja: "「安心しろ。」\nイワシ先輩が言った。\n「溶けるのは、終わりじゃない。」\n「次へ進むための準備だ。」\nぼくは首を振った。「どういうこと？」\n先輩は少しだけ笑った。\n「俺はここで役目を終える。」\n「ここで溶けて、おじさんの力になるんだ。」",
    learning: {
      vocab: [
        { word: "worry", mean: "心配する" },
        { word: "preparation", mean: "準備" },
        { word: "shake", mean: "振る（過去形: shook）" },
        { word: "mean", mean: "意味する" },
        { word: "role", mean: "役割、役目" },
        { word: "power", mean: "力、エネルギー" }
      ],
      grammar: {
        title: "未来を表す will",
        desc: "「〜するつもりだ、〜になるだろう」という強い意志や未来の出来事を表します。",
        key: "I will melt here, and become..."
      }
    },
    color: "bg-blue-50", accent: "text-blue-600", mood: { rate: 0.95, pitch: 1.0 }, image: "images/006/20.jpg", startTime: 380
  },
  {
    title: "Part 6: Beyond That (2/4)",
    rubyText: [
      { w: "I", r: "アイ" }, { w: "lost", r: "ロスト" }, { w: "my", r: "マイ" }, { w: "words.", r: "ワーズ", s: true }, 
      { w: "Just", r: "ジャスト" }, { w: "then,", r: "ゼン", s: true }, { w: "Pepsin", r: "ペプシン" }, { w: "waved", r: "ウェイブド" }, { w: "his", r: "ヒズ" }, { w: "hand", r: "ハンド", s: true }, 
      { w: "grandly.", r: "グランドリー", s: true }, { w: "A", r: "ア" }, { w: "giant", r: "ジャイアント" }, { w: "wave", r: "ウェーブ" }, { w: "was", r: "ワズ" }, { w: "born", r: "ボーン", s: true }, 
      { w: "in", r: "イン" }, { w: "the", r: "ザ" }, { w: "lake.", r: "レイク", s: true }, 
      { w: "The", r: "ザ" }, { w: "acid", r: "アシッド" }, { w: "wave", r: "ウェーブ" }, { w: "enveloped", r: "エンベロップト" }, { w: "his", r: "ヒズ" }, { w: "body.", r: "ボディ", s: true }, 
      { w: "Even", r: "イーブン" }, { w: "so,", r: "ソー", s: true }, { w: "the", r: "ザ" }, { w: "Sardine", r: "サーディン" }, { w: "was", r: "ワズ" }, { w: "smiling.", r: "スマイリング", s: true }, 
      { w: "\"But,", r: "バット", s: true }, { w: "there", r: "ゼア" }, { w: "is", r: "イズ" }, { w: "still", r: "スティル" }, { w: "more", r: "モア" }, { w: "ahead", r: "アヘッド" }, { w: "for", r: "フォー" }, { w: "you.\"", r: "ユー", s: true }, 
      { w: "\"Beyond", r: "ビヨンド" }, { w: "here,", r: "ヒア", s: true }, { w: "is", r: "イズ" }, { w: "a", r: "ア" }, { w: "much", r: "マッチ" }, { w: "wider", r: "ワイダー" }, { w: "world.\"", r: "ワールド", s: true }
    ],
    en: "I lost my words.\nJust then, Pepsin waved his hand\ngrandly. A giant wave was born\nin the lake.\nThe acid wave enveloped his body.\nEven so, the Sardine was smiling.\n\"But, there is still more ahead for you.\"\n\"Beyond here, is a much wider world.\"",
    ja: "ぼくは言葉を失った。\nそのとき、ペプシンが大きく手を振った。\n湖に巨大な波が生まれる。\n酸の波が、イワシ先輩の体を包み込んだ。\nそれでも先輩は笑っていた。\n「だが、お前にはまだ先がある。」\n「この先には、もっと広い世界がある。」",
    learning: {
      vocab: [
        { word: "lose one's words", mean: "言葉を失う（過去形: lost）" },
        { word: "wave", mean: "（手を）振る" },
        { word: "grandly", mean: "大げさに、堂々と" },
        { word: "giant", mean: "巨大な" },
        { word: "Even so", mean: "それでも" },
        { word: "ahead", mean: "前方に、先に" }
      ],
      grammar: {
        title: "much + 比較級",
        desc: "「much wider」で、「はるかに広い、ずっと広い」と比較を強調します。",
        key: "...is a much wider world."
      }
    },
    color: "bg-indigo-100", accent: "text-indigo-700", mood: { rate: 1.0, pitch: 0.95 }, image: "images/006/21.jpg", startTime: 400
  },
  {
    title: "Part 6: Beyond That (3/4)",
    rubyText: [
      { w: "\"Now", r: "ナウ" }, { w: "go,", r: "ゴー", s: true }, { w: "Taiyaki.\"", r: "タイヤキ", s: true }, 
      { w: "\"Your", r: "ユア" }, { w: "journey", r: "ジャーニー" }, { w: "is", r: "イズ" }, { w: "not", r: "ノット" }, { w: "over", r: "オーバー" }, { w: "yet.\"", r: "イェット", s: true }, 
      { w: "A", r: "ア" }, { w: "fierce", r: "フィアス" }, { w: "flow", r: "フロウ" }, { w: "was", r: "ワズ" }, { w: "born.", r: "ボーン", s: true }, 
      { w: "I", r: "アイ" }, { w: "was", r: "ワズ" }, { w: "pushed", r: "プッシュト" }, { w: "out", r: "アウト" }, { w: "by", r: "バイ" }, { w: "that", r: "ザット" }, { w: "flow.", r: "フロウ", s: true }, 
      { w: "\"Wait!", r: "ウェイト", s: true }, { w: "Senpai!\"", r: "センパイ", s: true }, 
      { w: "By", r: "バイ" }, { w: "the", r: "ザ" }, { w: "time", r: "タイム", s: true }, { w: "I", r: "アイ" }, { w: "shouted,", r: "シャウティッド", s: true }, 
      { w: "his", r: "ヒズ" }, { w: "figure", r: "フィギュア" }, { w: "had", r: "ハド" }, { w: "disappeared", r: "ディスアピアード", s: true }, 
      { w: "into", r: "イントゥ" }, { w: "the", r: "ザ" }, { w: "acid", r: "アシッド" }, { w: "fog.", r: "フォグ", s: true }
    ],
    en: "\"Now go, Taiyaki.\"\n\"Your journey is not over yet.\"\nA fierce flow was born.\nI was pushed out by that flow.\n\"Wait! Senpai!\"\nBy the time I shouted,\nhis figure had disappeared\ninto the acid fog.",
    ja: "「さあ行け、たいやき。」\n「お前の旅は、まだ終わっていない。」\n激しい流れが生まれた。\nぼくはその流れに押し出される。\n「待って！ 先輩！」\n叫んだときには、\nイワシ先輩の姿は酸の霧の中へ消えていた。",
    learning: {
      vocab: [
        { word: "over", mean: "終わって" },
        { word: "yet", mean: "（否定文で）まだ" },
        { word: "fierce", mean: "激しい、猛烈な" },
        { word: "figure", mean: "姿" },
        { word: "disappear", mean: "消える" }
      ],
      grammar: {
        title: "過去完了形 (had + 過去分詞)",
        desc: "「私が叫んだ」という過去の時点よりも、【さらに前に】姿が消えてしまっていたことを表します。",
        key: "his figure had disappeared..."
      }
    },
    color: "bg-purple-100", accent: "text-purple-700", mood: { rate: 1.05, pitch: 1.1 }, image: "images/006/22.jpg", startTime: 420
  },
  {
    title: "Part 6: Beyond That (4/4)",
    rubyText: [
      { w: "The", r: "ザ" }, { w: "flow", r: "フロウ" }, { w: "did", r: "ディド" }, { w: "not", r: "ノット" }, { w: "stop.", r: "ストップ", s: true }, 
      { w: "I", r: "アイ" }, { w: "was", r: "ワズ" }, { w: "pushed", r: "プッシュト" }, { w: "out", r: "アウト" }, { w: "into", r: "イントゥ" }, { w: "a", r: "ア" }, { w: "dark", r: "ダーク" }, { w: "corridor.", r: "コリドー", s: true }, 
      { w: "Ahead", r: "アヘッド" }, { w: "of", r: "オブ" }, { w: "that--", r: "ザット", s: true }, 
      { w: "a", r: "ア" }, { w: "pale,", r: "ペイル", s: true }, { w: "glowing", r: "グローイング" }, { w: "pink", r: "ピンク" }, { w: "forest", r: "フォレスト", s: true }, 
      { w: "came", r: "ケイム" }, { w: "into", r: "イントゥ" }, { w: "view.", r: "ビュー", s: true }, 
      { w: "(To", r: "トゥ" }, { w: "be", r: "ビー" }, { w: "continued", r: "コンティニュード" }, { w: "in", r: "イン" }, { w: "Episode", r: "エピソード" }, { w: "2)", r: "ツー", s: true }
    ],
    en: "The flow did not stop.\nI was pushed out into a dark corridor.\nAhead of that--\na pale, glowing pink forest\ncame into view.\n(To be continued in Episode 2)",
    ja: "流れは止まらない。\nぼくは暗い回廊へ押し出される。\nその先に――\n淡く光る 桃色の森 が見えてきた。\n（第2話へつづく）",
    learning: {
      vocab: [
        { word: "corridor", mean: "回廊、通路" },
        { word: "ahead of ~", mean: "〜の先に" },
        { word: "pale", mean: "淡い、薄い" },
        { word: "glowing", mean: "光を放つ、輝く" },
        { word: "forest", mean: "森" }
      ],
      grammar: {
        title: "熟語: come into view",
        desc: "「視界に入ってくる、見えてくる」という意味の決まり文句です。",
        key: "a pale, glowing pink forest came into view."
      }
    },
    color: "bg-pink-100", accent: "text-pink-700", mood: { rate: 1.0, pitch: 1.0 }, image: "images/006/23.jpg", startTime: 440
  }
];

const QUIZ_POOL = [
  { q: "What was Taiyaki baked on?", options: ["An iron plate", "A frying pan", "A hot stone"], a: 0, exp: "Part 1で「I was baked on an iron plate（鉄板の上で焼かれた）」とあります。" },
  { q: "How did Taiyaki feel about being baked every day?", options: ["He loved it", "He was sick of it", "He didn't care"], a: 1, exp: "Part 1に「I was already sick of it（もううんざりだった）」とあります。" },
  { q: "Who did Taiyaki have a big fight with?", options: ["The Sardine", "The man at the shop", "A customer"], a: 1, exp: "Part 1で店のおじさん（the man at the shop）と大喧嘩をしました。" },
  { q: "Where did Taiyaki escape to?", options: ["The river", "The forest", "The sea"], a: 2, exp: "Part 1で「escaped right into the sea（海へ逃げ込んだ）」とあります。" },
  { q: "How did swimming in the sea feel at first?", options: ["Really cold", "Really good", "Very scary"], a: 1, exp: "Part 1で「felt really good（とても気持ちよかった）」と表現されています。" },
  { q: "What did Taiyaki have in the sea?", options: ["A new shop", "Friends and plenty of food", "An iron plate"], a: 1, exp: "Part 1で「仲間（friends）がいてエサ（food）もたくさんあった」と語られています。" },
  { q: "What did Taiyaki casually bite one day?", options: ["A crab", "A shrimp", "A squid"], a: 1, exp: "Part 1で「casually bit a shrimp（何気なくエビをかじった）」とあります。" },
  { q: "Where is Taiyaki now after biting the shrimp?", options: ["In the man's mouth", "In the fish tank", "On the iron plate"], a: 0, exp: "釣り上げられ、「Now, I am in the man's mouth（今おじさんの口の中にいる）」と言っています。" },
  { q: "What kind of sound does Taiyaki hear in the dark?", options: ["A loud music", "A regular chewing sound", "A crying sound"], a: 1, exp: "口の中で「regular chewing sound（規則正しい咀嚼の音）」が聞こえます。" },
  { q: "What is happening to Taiyaki's body in the mouth?", options: ["It is growing bigger", "It is turning into gold", "It is being crushed finer"], a: 2, exp: "「my body was crushed finer and finer（どんどん細かく砕かれた）」とあります。" },
  { q: "Who did Taiyaki see standing with scissors?", options: ["Pepsin", "Amylase", "The shop owner"], a: 1, exp: "Part 2でハサミを持ったアミラーゼ（Amylase）と出会います。" },
  { q: "What is Amylase's job?", options: ["To bake Taiyaki", "To untie Taiyaki's body", "To sing a song"], a: 1, exp: "「I am helping to untie your body（体をほどくお手伝いをしている）」と言っています。" },
  { q: "What is Taiyaki's true identity according to Amylase?", options: ["Sugar", "Starch", "Protein"], a: 1, exp: "「Your body is starch（あなたの体はデンプン）」と教えられます。" },
  { q: "How did Taiyaki feel when his chains were untied?", options: ["Very painful", "Somewhat nostalgic", "Very angry"], a: 1, exp: "嫌な気はせず、「somewhat nostalgic（どこか懐かしい）」と感じました。" },
  { q: "Where was Taiyaki washed into after seeing Amylase?", options: ["A dark passage", "A bright river", "A kitchen"], a: 0, exp: "Part 3で「washed into a dark passage（暗い通路へ押し流された）」とあります。" },
  { q: "What was the dark slide like?", options: ["Short and bright", "Long, dark, and unstoppable", "Warm and safe"], a: 1, exp: "滑り台は「Long, dark, and unstoppable（長くて暗くて止まらない）」でした。" },
  { q: "Could Taiyaki go back up the slide?", options: ["Yes, easily", "No, he could not", "Only with help"], a: 1, exp: "「I could not go back, either（後ろへ戻ることもできない）」とあります。" },
  { q: "What did Taiyaki fall straight into?", options: ["Liquid", "A soft bed", "Ice"], a: 0, exp: "「fell straight into liquid（液体の中へ落ちた）」と描写されています。" },
  { q: "Was the liquid refreshing like the sea?", options: ["Yes, very much", "No, it was thick and gooey", "It was exactly like the sea"], a: 1, exp: "爽快さはなく「thick and gooey（ドロドロしている）」でした。" },
  { q: "What is the name of the place Taiyaki reached?", options: ["The Sweet Lake", "The Acid Lake", "The Cold River"], a: 1, exp: "すべてを溶かす「the Acid Lake（酸の湖）」に辿り着きました。" },
  { q: "Who grabbed Taiyaki strongly in the Acid Lake?", options: ["Pepsin", "Amylase", "Sardine-senpai"], a: 2, exp: "Part 4でイワシ先輩（Sardine-senpai）に腕を掴まれます。" },
  { q: "Where did Taiyaki swim with the Sardine before?", options: ["In the pool", "In the sea", "In a fish tank"], a: 1, exp: "「I swam with in the sea（海で一緒に泳いでいた）」とあります。" },
  { q: "What was happening to the Sardine's silver body?", options: ["It was shining brighter", "It was starting to crumble", "It was turning red"], a: 1, exp: "銀色の体は「starting to crumble（崩れはじめている）」状態でした。" },
  { q: "Who was standing quietly on the acid lake?", options: ["A fat man", "A thin man named Pepsin", "Amylase"], a: 1, exp: "Part 5で「a thin man was standing（細身の男が立っていた）」、名前はPepsinです。" },
  { q: "What does the Acid Lake represent?", options: ["The mouth", "The stomach", "The heart"], a: 1, exp: "ペプシンが「This is the stomach（ここは胃）」と言っています。" },
  { q: "What melts in the stomach according to Pepsin?", options: ["Only plants", "Meat, bones, shells, everything", "Only ice"], a: 1, exp: "「Here, meat, bones, shells, everything melts.」と言っています。" },
  { q: "What is the Sardine's role in the stomach?", options: ["To escape", "To melt and become the man's power", "To fight Pepsin"], a: 1, exp: "「melt here, and become the man's power（溶けておじさんの力になる）」と語ります。" },
  { q: "What enveloped the Sardine's body?", options: ["A giant acid wave", "A bright light", "A dark shadow"], a: 0, exp: "ペプシンが手を振ると「The acid wave enveloped his body」となりました。" },
  { q: "Did the Sardine cry when he was enveloped?", options: ["Yes, he cried loudly", "No, he was smiling", "He was angry"], a: 1, exp: "波に飲まれても「Even so, the Sardine was smiling（それでも笑っていた）」とあります。" },
  { q: "What did Taiyaki see ahead at the very end?", options: ["A dark wall", "A pale, glowing pink forest", "The sea"], a: 1, exp: "回廊の先に「a pale, glowing pink forest（淡く光る桃色の森）」が見えました。" }
];

const SCRAMBLE_POOL = [
  { q: "毎日毎日、ぼくは鉄板の上で焼かれていた。", w: ["Every", "day", "I", "was", "baked", "on", "an", "iron", "plate"], o: [0, 1, 2, 3, 4, 5, 6, 7, 8] },
  { q: "正直、もううんざりだった。", w: ["Honestly", "I", "was", "already", "sick", "of", "it"], o: [0, 1, 2, 3, 4, 5, 6] },
  { q: "ついに店のおじさんと大げんかをした。", w: ["I", "finally", "had", "a", "big", "fight", "with", "the", "man"], o: [0, 1, 2, 3, 4, 5, 6, 7, 8] },
  { q: "ぼくは店を飛び出した。", w: ["I", "ran", "out", "of", "the", "shop"], o: [0, 1, 2, 3, 4, 5] },
  { q: "海での泳ぎは、とても気持ちよかった。", w: ["Swimming", "in", "the", "sea", "felt", "really", "good"], o: [0, 1, 2, 3, 4, 5, 6] },
  { q: "広くて、自由で、どこまでも続いていた。", w: ["It", "was", "wide", "free", "and", "endless"], o: [0, 1, 2, 3, 4, 5] },
  { q: "ここには一緒に泳ぐ仲間がいた。", w: ["I", "had", "friends", "to", "swim", "with", "here"], o: [0, 1, 2, 3, 4, 5, 6] },
  { q: "その終わりは突然やってきた。", w: ["The", "end", "came", "suddenly"], o: [0, 1, 2, 3] },
  { q: "何気なくエビをかじった。", w: ["I", "casually", "bit", "a", "shrimp"], o: [0, 1, 2, 3, 4] },
  { q: "ぼくは今、おじさんの口の中にいる。", w: ["Now", "I", "am", "in", "the", "man's", "mouth"], o: [0, 1, 2, 3, 4, 5, 6] },
  { q: "ぼくの体はどんどん細かく砕かれていった。", w: ["My", "body", "was", "crushed", "finer", "and", "finer"], o: [0, 1, 2, 3, 4, 5, 6] },
  { q: "ふと人の気配がした。", w: ["I", "felt", "someone's", "presence"], o: [0, 1, 2, 3] },
  { q: "あなたの体をほどくお手伝いをしているの。", w: ["I", "am", "helping", "to", "untie", "your", "body"], o: [0, 1, 2, 3, 4, 5, 6] },
  { q: "長くつながった鎖でできているの。", w: ["It", "is", "made", "of", "long", "connected", "chains"], o: [0, 1, 2, 3, 4, 5, 6] },
  { q: "その鎖をほどくことが、私の役目。", w: ["Untying", "those", "chains", "is", "my", "job"], o: [0, 1, 2, 3, 4, 5] },
  { q: "形は少しずつ変わっていく。", w: ["My", "shape", "changed", "little", "by", "little"], o: [0, 1, 2, 3, 4, 5] },
  { q: "嫌な気持ちはしない。", w: ["I", "did", "not", "feel", "bad"], o: [0, 1, 2, 3, 4] },
  { q: "あなたはもう、ただのたいやきじゃない。", w: ["You", "are", "not", "just", "a", "taiyaki", "anymore"], o: [0, 1, 2, 3, 4, 5, 6] },
  { q: "ぼくは暗い通路へと押し流された。", w: ["I", "was", "washed", "into", "a", "dark", "passage"], o: [0, 1, 2, 3, 4, 5, 6] },
  { q: "壁がゆっくり動いた。", w: ["The", "walls", "moved", "slowly"], o: [0, 1, 2, 3] },
  { q: "後ろへ戻ることもできない。", w: ["I", "could", "not", "go", "back", "either"], o: [0, 1, 2, 3, 4, 5] },
  { q: "視界が大きく開けた。", w: ["My", "view", "opened", "wide"], o: [0, 1, 2, 3] },
  { q: "ぼくの体は、そのまま液体の中へ落ちた。", w: ["My", "body", "fell", "straight", "into", "liquid"], o: [0, 1, 2, 3, 4, 5] },
  { q: "液体は体の奥まで染み込んでくる。", w: ["The", "liquid", "soaked", "deep", "into", "my", "body"], o: [0, 1, 2, 3, 4, 5, 6] },
  { q: "誰かがぼくの体を強くつかんだ。", w: ["Someone", "grabbed", "my", "body", "strongly"], o: [0, 1, 2, 3, 4] },
  { q: "ここで気を失えば、ただ消えるだけだ。", w: ["If", "you", "pass", "out", "here", "you", "will", "disappear"], o: [0, 1, 2, 3, 4, 5, 6, 7] },
  { q: "ぼくはゆっくり目を開けた。", w: ["I", "slowly", "opened", "my", "eyes"], o: [0, 1, 2, 3, 4] },
  { q: "この場所が、ぼくらを少しずつ溶かしている。", w: ["This", "place", "was", "melting", "us", "little", "by", "little"], o: [0, 1, 2, 3, 4, 5, 6, 7] },
  { q: "霧の向こうに、細身の男が立っていた。", w: ["Beyond", "the", "fog", "a", "thin", "man", "was", "standing"], o: [0, 1, 2, 3, 4, 5, 6, 7] },
  { q: "流れは止まらない。", w: ["The", "flow", "did", "not", "stop"], o: [0, 1, 2, 3, 4] }
];

const FILL_IN_THE_BLANK_POOL = [
  { q: "Every day, I was baked ------- an iron plate.", options: ["in", "on", "at", "by"], a: 1, exp: "「鉄板の上に」なので前置詞 on を使います。" },
  { q: "------- a sizzling sound, over and over.", options: ["Make", "Makes", "Making", "Made"], a: 2, exp: "「〜しながら」と同時進行の状況を表すため、-ing形 (Making) になります。" },
  { q: "Honestly, I was already sick ------- it.", options: ["for", "at", "of", "off"], a: 2, exp: "「〜にうんざりする」は be sick of ~ という熟語です。" },
  { q: "I ------- right into the sea.", options: ["escaped", "escape", "escaping", "escapes"], a: 0, exp: "過去の話なので過去形 escaped が入ります。" },
  { q: "Swimming in the sea ------- the first time felt good.", options: ["at", "in", "to", "for"], a: 3, exp: "「初めて」は for the first time と言います。" },
  { q: "There was ------- of food, too.", options: ["many", "plenty", "lot", "much"], a: 1, exp: "「たくさんの〜」は plenty of ~ で表します。" },
  { q: "One day, I casually ------- a shrimp.", options: ["bite", "bit", "bitten", "bites"], a: 1, exp: "bite（かじる）の過去形 bit が入ります。" },
  { q: "Ah... my body is breaking -------.", options: ["away", "out", "apart", "down"], a: 2, exp: "「バラバラに壊れる」は break apart です。" },
  { q: "I turned ------- and saw a woman.", options: ["around", "over", "up", "in"], a: 0, exp: "「振り向く」は turn around です。" },
  { q: "She ------- gently.", options: ["smile", "smiled", "smiling", "smiles"], a: 1, exp: "過去の出来事なので過去形の smiled が入ります。" },
  { q: "It is ------- of long chains.", options: ["make", "made", "making", "makes"], a: 1, exp: "「〜で作られている」は be made of です。" },
  { q: "Every ------- the scissors moved, the chains untied.", options: ["time", "day", "hour", "moment"], a: 0, exp: "「〜するたびに」は Every time を使います。" },
  { q: "My shape changed little ------- little.", options: ["to", "by", "for", "with"], a: 1, exp: "「少しずつ」は little by little と言います。" },
  { q: "It felt like I was ------- to my smaller self.", options: ["return", "returns", "returned", "returning"], a: 3, exp: "過去進行形「戻っているような気がした」なので -ing形が入ります。" },
  { q: "You are not just a taiyaki -------.", options: ["already", "yet", "anymore", "still"], a: 2, exp: "否定文と一緒に使って「もう〜ではない」を表す anymore が入ります。" },
  { q: "Seen ------- by Amylase, I was washed into a dark passage.", options: ["away", "off", "out", "over"], a: 1, exp: "「見送る」は see off です。ここでは分詞構文で Seen off となっています。" },
  { q: "I was carried deeper ------- deeper.", options: ["or", "but", "and", "so"], a: 2, exp: "比較級 + and + 比較級 で「ますます深く（どんどん奥へ）」となります。" },
  { q: "My body fell ------- into liquid.", options: ["straight", "strong", "fast", "deep"], a: 0, exp: "「まっすぐに」を意味する straight が入ります。" },
  { q: "The liquid soaked ------- into my body.", options: ["deep", "deeply", "depth", "deepen"], a: 0, exp: "「深く染み込む」は soak deep と表現できます。" },
  { q: "My consciousness was fading -------.", options: ["out", "off", "away", "up"], a: 2, exp: "「薄れていく、消えていく」は fade away です。" },
  { q: "If you pass ------- here, you will disappear.", options: ["away", "by", "out", "on"], a: 2, exp: "「気を失う、気絶する」は pass out です。" },
  { q: "He ------- his shoulders.", options: ["shook", "shrugged", "moved", "raised"], a: 1, exp: "「肩をすくめる」は shrug one's shoulders です。" },
  { q: "His silver body was ------- to crumble.", options: ["start", "starts", "starting", "started"], a: 2, exp: "過去進行形 (was + -ing) なので starting が入ります。" },
  { q: "Still, he said in a ------- voice.", options: ["calm", "cold", "loud", "angry"], a: 0, exp: "「落ち着いた声で」は in a calm voice です。" },
  { q: "A voice echoed from deep ------- the lake.", options: ["in", "within", "inside", "under"], a: 1, exp: "「〜の奥深くから」は deep within を使います。" },
  { q: "He stood quietly, ------- if stepping on the water.", options: ["as", "like", "so", "even"], a: 0, exp: "「まるで〜かのように」は as if ~ です。" },
  { q: "Here, the shapes of living things -------.", options: ["unravel", "unraveled", "unraveling", "unravels"], a: 1, exp: "過去の情景を描写しているため、過去形の unraveled が入ります。" },
  { q: "Pepsin looked ------- at me.", options: ["up", "down", "around", "away"], a: 1, exp: "「〜を見下ろす」は look down at ~ です。" },
  { q: "The acid fog spread slowly, ------- my body.", options: ["envelop", "envelops", "enveloped", "enveloping"], a: 3, exp: "「〜を包み込みながら」と付帯状況を表す分詞構文 enveloping (-ing形) が入ります。" },
  { q: "A pale, glowing pink forest came ------- view.", options: ["to", "in", "into", "for"], a: 2, exp: "「視界に入ってくる、見えてくる」は come into view です。" }
];

export default {
  id: "w8A6Rmrd",
  title: "Tokero! Taiyaki-kun: Part 1",
  level: "LEVEL 3",
  category: "Science",
  content: STORY_DATA,
  quizzes: QUIZ_POOL,
  puzzles: SCRAMBLE_POOL,
  fills: FILL_IN_THE_BLANK_POOL,
};
